export const getElementsByClassName = (classname: string) => {
  const collection = document.getElementsByClassName(classname);
  if (!collection) {
    throw new Error(`Could not find elements with class: ${classname}`);
  }
  return collection as HTMLCollectionOf<HTMLElement>;
};
